/* jshint esversion: 6 */
/* jshint ignore:start */

import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { getBackendBaseURL, getApiBaseURL } from '../utils/backendUrl';

const MyContext = createContext();

const MyProvider = ({ children }) => {

    const backendBaseURL = `${getBackendBaseURL().replace(/\/+$/, '')}/`;
    const basUrl = getApiBaseURL();
    const imageBaseURL = backendBaseURL;
    const paymentBaseURL = backendBaseURL;

    const [updateId, setUpdateId] = useState(0);

    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [bio, setBio] = useState();
    const [number, setNumber] = useState();
    const [ccode, setCcode] = useState();
    const [birthdate, setBirthDate] = useState();
    const [gender, setGender] = useState();
    const [goal, setGoal] = useState();
    const [nearby, setNearby] = useState();
    const [hobbies, setHobbies] = useState();
    const [languages, setLanguages] = useState();
    const [religion, setReligion] = useState();
    const [preference, setPreference] = useState();
    const [latitude, setLatitude] = useState();
    const [longitude, setLongitude] = useState();
    const [uid, setUid] = useState();
    const [profileId, setProfileId] = useState();
    const [registerUid, setRegisterUid] = useState('');
    const [payClose, setPayClose] = useState();
    const [planId, setPlanId] = useState();
    const [transactionId, setTransactionId] = useState();
    const [toggleButton, setToggleButton] = useState(false);
    const [page, setPageName] = useState();
    const [amount, setAmount] = useState();
    const [buyCoin, setBuyCoin] = useState();
    const [purchaseId, setPurchaseId] = useState();
    const [walletCoin, setWalletCoin] = useState();
    const [demo, setDemo] = useState();
    const [error, setError] = useState();
    const [blockId, setBlockId] = useState();
    const [details, setDetails] = useState();
    const [chatId, setChatId] = useState("");
    const [chatUserName, setChatUserName] = useState();
    const [currency, setCurrency] = useState();
    const [isVoiceCalling, setIsVoiceCalling] = useState(false);
    const [isVideoCalling, setIsVideoCalling] = useState(false);
    const [callStatus, setCallstatus] = useState(false);
    const [atendCall, setAtendCall] = useState(false);
    const [toastMsg, setToastMsg] = useState();
    const [toastShow, setToastShow] = useState(false);
    const [valodateId, setValidateId] = useState(false);
    const [agoraAppId, setAgoraAppId] = useState();
    const [callMode, setCallMode] = useState("audio_video");
    const [callProvider, setCallProvider] = useState("agora");
    const [onesignalAppId, setOnesignalAppId] = useState();
    const [color, setColor] = useState("");
    const [button, setButton] = useState(true);
    const [socketDebugToast, setSocketDebugToast] = useState("0");
    const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
    const [incognitoModeEnabled, setIncognitoModeEnabled] = useState("1");
    const [passportModeEnabled, setPassportModeEnabled] = useState("1");
    const [superlikeModeEnabled, setSuperlikeModeEnabled] = useState("1");
    const [boostModeEnabled, setBoostModeEnabled] = useState("1");

    const isIncognitoMasterEnabled = incognitoModeEnabled !== "0";
    const isPassportMasterEnabled = passportModeEnabled !== "0";
    const isSuperLikeMasterEnabled = superlikeModeEnabled !== "0";
    const isBoostMasterEnabled = boostModeEnabled !== "0";

    useEffect(() => {
        let isMounted = true;
        const checkMaintenance = async () => {
            try {
                const res = await axios.get(`${basUrl}smstypeapi`);
                if (isMounted && res?.data) {
                    if (res.data.incognito_mode_enabled !== undefined) {
                        setIncognitoModeEnabled(String(res.data.incognito_mode_enabled));
                    }
                    if (res.data.passport_mode_enabled !== undefined) {
                        setPassportModeEnabled(String(res.data.passport_mode_enabled));
                    }
                    if (res.data.superlike_mode_enabled !== undefined) {
                        setSuperlikeModeEnabled(String(res.data.superlike_mode_enabled));
                    }
                    if (res.data.boost_mode_enabled !== undefined) {
                        setBoostModeEnabled(String(res.data.boost_mode_enabled));
                    }
                    const mode = String(
                        res.data.maintainance_Enabled ??
                        res.data.maintainanceenabled ??
                        res.data.mode ??
                        ''
                    ).trim().toLowerCase();
                    const isEnabled = mode === 'yes' || mode === '1' || mode === 'true' || mode === 'enabled';
                    setIsMaintenanceMode(isEnabled);
                }
            } catch (err) {
                // Ignore transient network errors
            }
        };

        checkMaintenance();
        const interval = setInterval(checkMaintenance, 5000);
        return () => {
            isMounted = false;
            clearInterval(interval);
        };
    }, [basUrl]);

    const Value = {
        name, setName,
        email, setEmail,
        password, setPassword,
        bio, setBio,
        number, setNumber,
        ccode, setCcode,
        birthdate, setBirthDate,
        gender, setGender,
        goal, setGoal,
        nearby, setNearby,
        hobbies, setHobbies,
        languages, setLanguages,
        religion, setReligion,
        preference, setPreference,
        latitude, setLatitude,
        longitude, setLongitude,
        uid, setUid,
        profileId, setProfileId,
        registerUid, setRegisterUid,
        updateId, setUpdateId,
        payClose, setPayClose,
        planId, setPlanId,
        transactionId, setTransactionId,
        toggleButton, setToggleButton,
        page, setPageName,
        amount, setAmount,
        buyCoin, setBuyCoin,
        purchaseId, setPurchaseId,
        walletCoin, setWalletCoin,
        demo, setDemo,
        details, setDetails,
        blockId, setBlockId,
        error, setError,
        chatId, setChatId,
        chatUserName, setChatUserName,
        currency, setCurrency,
        isVoiceCalling, setIsVoiceCalling,
        isVideoCalling, setIsVideoCalling,
        callStatus, setCallstatus,
        atendCall, setAtendCall,
        toastMsg, setToastMsg,
        toastShow, setToastShow,
        valodateId, setValidateId,
        agoraAppId, setAgoraAppId,
        callMode, setCallMode,
        callProvider, setCallProvider,
        onesignalAppId, setOnesignalAppId,
        button, setButton,
        color, setColor,
        basUrl, imageBaseURL, paymentBaseURL,
        socketDebugToast, setSocketDebugToast,
        isMaintenanceMode, setIsMaintenanceMode,
        superlikeModeEnabled, setSuperlikeModeEnabled,
        boostModeEnabled, setBoostModeEnabled,
        isIncognitoMasterEnabled, isPassportMasterEnabled,
        isSuperLikeMasterEnabled, isBoostMasterEnabled,
    };

    return (
        <MyContext.Provider value={Value}>
            {children}
        </MyContext.Provider>
    );
};

export { MyContext, MyProvider };
/* jshint ignore:end */
